import { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import path from "path";
import { useEffect } from "react";

import { setRouter } from "@tm/insurance/navigation";
import { persistUtmParams } from "@tm/insurance/utils";
import { ErrorBoundary, ErrorScreen } from "@tm/ui/ui-container";

import { loadGTM } from "@tm/utility";
import "react-day-picker/dist/style.css";
import "./styles.css";

// Magic import
path.resolve("./next.config.js");

function CustomApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  setRouter(router);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    persistUtmParams(queryParams);
  }, []);

  useEffect(() => {
    loadGTM();
  }, []);

  return (
    <>
      {" "}
      {/* <GlobalStyles /> */}
      <Head>
        <title>Tripmoney Insurance</title>
      </Head>
      <main className="app">
        <ErrorBoundary onError={(error) => <ErrorScreen error={error} />}>
          <Component {...pageProps} />
        </ErrorBoundary>
      </main>
    </>
  );
}

export default CustomApp;
